import { useState, useCallback } from "react";

const FILE_SIZE_50MB = 50 * 1024 * 1024;

interface FileValidationResult {
  isValid: boolean;
  error: string | null;
}

export const useFileValidation = () => {
  const [validationError, setValidationError] = useState<string | null>(null);

  const validateFile = useCallback((file: File): FileValidationResult => {
    // Check file extension
    if (!file.name.toLowerCase().endsWith(".xlsx")) {
      const error = "Please upload a valid .xlsx file. .xls files are not supported.";
      setValidationError(error);
      return { isValid: false, error };
    }

    // Check file size
    if (file.size > FILE_SIZE_50MB) {
      const error = "File size must be less than 50MB. Please select a smaller file.";
      setValidationError(error);
      return { isValid: false, error };
    }

    // File is valid
    setValidationError(null);
    return { isValid: true, error: null };
  }, []);

  const clearValidationError = useCallback(() => {
    setValidationError(null);
  }, []);

  return {
    validateFile,
    validationError,
    setValidationError,
    clearValidationError,
  };
};

